import AEMWrapper from "aem/ComponentWrapper";
import React from "react";
import ContainerWrapper from "concierge-alias-aem/ContainerWrapper";
import loadable from "@loadable/component";
import meta from "./aem-meta";

const Component = loadable(
  () =>
    import(
      /* webpackChunkName: "component-drop-down-flyout-menu/aem-component" */ "./aem-component"
    ),
  {
    fallback: <></>
  }
);

export default AEMWrapper(meta, Component, {
  wrapper: ContainerWrapper
});
